import type { RefObject } from 'react'
import { useEffect, useState } from 'react'

/**
 * Tracks the natural content height of the Trumbowyg editor inside a wrapper element.
 */
export function useEditorContentHeight(
  wrapperRef: RefObject<HTMLElement | null>,
  contentRevision: string
): number {
  const [contentHeight, setContentHeight] = useState(0)

  useEffect(() => {
    const wrapper = wrapperRef.current
    if (!wrapper) {
      return
    }

    const measure = () => {
      const editor = wrapper.querySelector('.trumbowyg-editor') as HTMLElement | null
      if (!editor) {
        setContentHeight(0)
        return
      }

      setContentHeight(Math.ceil(editor.scrollHeight))
    }

    measure()

    if (typeof ResizeObserver === 'undefined') {
      return
    }

    const observer = new ResizeObserver(measure)
    observer.observe(wrapper)

    const editor = wrapper.querySelector('.trumbowyg-editor')
    if (editor) {
      observer.observe(editor)
    }

    return () => {
      observer.disconnect()
    }
  }, [wrapperRef, contentRevision])

  return contentHeight
}
